import { useCallback, useEffect, useState } from 'react';

import { AxiosResponse } from 'axios';

import { Exclusion } from '../../types/Exclusions';
import { httpGet } from '../../../../../components/utils';

const useGetExclusions = (kind: string) => {
    const [data, setData] = useState<Exclusion[]>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    const fetchExclusions = useCallback(async () => {
        setIsFetching(true);
        setError(undefined);

        try {
            const response = (await httpGet(`/incidents/exclusions/${kind}`)) as unknown as AxiosResponse<Exclusion[]>;

            setData(response.data);
        } catch (err) {
            setError('Failed to get exclusions from server');
        }

        setIsFetching(false);
    }, [kind]);

    useEffect(() => {
        if (kind) fetchExclusions();
    }, [fetchExclusions, kind]);

    return { data, isFetching, error, refetch: fetchExclusions };
};

export default useGetExclusions;
